import { Layout } from "@/components/Layout";
import { useCart } from "@/context/CartContext";
import { useI18n } from "@/context/I18nContext";
import { ProductCard } from "@/components/ProductCard";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Wishlist() {
  const { wishlist } = useCart();
  const { t } = useI18n();
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="font-display font-bold text-3xl mb-6 flex items-center gap-2"><Heart className="w-7 h-7 text-primary" />{t("myWishlist")}</h1>
        {wishlist.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-muted-foreground">{t("noSaved")}</p>
            <Link to="/products"><Button className="mt-4 rounded-full">{t("browseProducts")}</Button></Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 lg:gap-6">
            {wishlist.map((p, i) => <ProductCard key={p.product_id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </Layout>
  );
}
